<template>
  <div class="zw_box">
		<div class="zw_banner"></div>
		<div class="list list_1">
			<div class="conter">
				<h1>导语</h1>
				<p>奇幻世界、古怪魍魉，笔墨未来，尽情书写！</br>由暗夜文学网主办，国内最豪征文大赛：千万推广费、千万奖金池，最专业的大型新媒体泛悬疑征文大赛，正式启动！这将是一场悬疑灵异作者的文学盛宴。暗夜文学网拥有国内顶尖新媒体专业团队，自建站初始，就立足于打造专业的灵异、悬疑网站，站内不断涌现如《凶棺》、《民间风水奇谭》、《窃玉生香》等订阅破百万的优秀作品，现已成为业内产量、更新速度最快的悬疑站点！</p>
				<p>我们始终坚信，好的故事=好的订阅+好的版权。文思泉涌，无处施展的情况，将不复存在，暗夜将用最温暖的态度扶持新人潜力作者。如今，我们联合优酷、爱奇艺、盛大游戏等国内大型ip公司，达成战略合作，深挖细耕，开启从网络文学到实体出版再到漫画、游戏、影视改编的直通车，为灵异悬疑作者提供完美展现自我，实现价值的舞台！</br>我们将为您提供：千万奖金+全网曝光+ip改编+全程指导+覆盖宣传+千万推广机会！</p>
				<p>我们不抢神，只造神！暗夜将至，神格塑造ing！</p>
			</div>
		</div>
		<div class="list list_2">
			<div class="conter">
				<h1>作品范围</h1>
				<ul>
					<li>
						<h4>悬疑向</h4>
						<p class="des">推理探索、悬疑分析、心理交锋、线索扑朔迷离、人物内心冲突不断…尽情发挥你的想象，开拓你的脑洞;</p>
						<p class="req"><span>要求：</span>字数以20-80万字之间为宜，全文不得出现鬼怪，小场景布局，以层层揭秘、悬疑概念为主</p>
						<p><span>参考作品:</span></p>
						<div class="img_box">
							<img src="../assets/images/zhengwen_2018/demo_1.png" alt="" srcset="">
						</div>
					</li>
					<li>
						<h4>灵异向</h4>
						<p class="des">灵异鬼怪、民间传说、风水秘术、文化传说、恐怖故事、寻龙点穴、考古挖宝等;</br>发挥你的思维，引领读者了解不为人知的秘密文化;</p>
						<p class="req"><span>要求：</span>字数以120万以上作品为佳，全文干练，节奏明显，故事深入人心；带领读者走进全新的世界</p>
						<p><span>参考作品:</span></p>
						<div class="img_box">
							<img src="../assets/images/zhengwen_2018/demo_2.png" alt="" srcset="">
						</div>
					</li>
					<li>
						<h4>现实向</h4>
						<p class="des">主导生活主线，情感冲突，人物矛盾等，描述贴近生活，青春校园，励志职场等故事。</p>
						<p class="req"><span>要求：</span>根据类别不同，字数不限，但人物情感活动，要以明显的悬念冲突为主；</p>
						<p><span>参考作品:</span></p>
						<div class="img_box">
							<img src="../assets/images/zhengwen_2018/demo_3.png" alt="" srcset="">
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="list list_3">
			<div class="conter">
				<h1>大赛奖励</h1>
				<div class="reward">
					<h3>巨额获奖机会+千万奖金+千万推广经费+全网名家打造计划</h3>
					<h4>大赛奖励<span></span></h4>
					<ul>
						<li>
							<img src="../assets/images/zhengwen_2018/cup_1.png" alt="">
							<div class="nav">
								<p class="title">暗夜金钻奖（1名）</p>
								<p>总价不低于50万的独家创作保障金+100%有声改编奖励+100%出版奖励+100%漫改奖励+总价不低于500万的影视改编机会+总价不低于300万的游戏改编机会；</p>
							</div>
						</li>
						<li>
							<img src="../assets/images/zhengwen_2018/cup_2.png" alt="">
							<div class="nav">
								<p class="title">暗夜铂金奖（2名）</p>
								<p>总价不低于30万的独家创作保障金+100%有声改编奖励+100%出版奖励+100%漫改奖励+总价不低于200万的影视改编机会；</p>
							</div>
						</li>
						<li>
							<img src="../assets/images/zhengwen_2018/cup_3.png" alt="">
							<div class="nav">
								<p class="title">暗夜荣耀奖（3名）</p>
								<p>总价不低于10万的独家创作保障金+100%有声改编奖励+100%出版奖励+总价不低于100万的漫画/影视/改编机会；</p>
							</div>
						</li>
					</ul>
					<h4 class="rew_top_title">最佳奖<span></span></h4>
					<div class="rew_top">
						<div><img src="../assets/images/zhengwen_2018/top_1.png" alt=""><p>最佳著作出版奖</br>（1名）</p><span>100%图书出版奖励</span></div>
						<div><img src="../assets/images/zhengwen_2018/top_2.png" alt=""><p>最佳影视改编价值奖</br>（1名）</p><span>全网百家影视公司独家推送</span></div>
						<div><img src="../assets/images/zhengwen_2018/top_3.png" alt=""><p>最佳文学新秀奖</br>（2名）</p><span>第二本作品总价不低于10万的独家创作保障奖金</span></div>
						<div><img src="../assets/images/zhengwen_2018/top_4.png" alt=""><p>最佳人气作品奖</br>（5名）</p><span>总价不低于5万的独家创作保障奖金+有声/漫画改编机会</span></div>
					</div>
					<div class="rew_tips">
						<p><span>温馨提示：</span></p>
						<p>1、同一作者参赛篇数不限，选取单项作品中的最高奖给予奖励；同一作品只可获取单项奖励，选取最高奖给予奖励；</p>		
						<p>2、此次征文活动中优秀作品将会获得图书、影视、漫画、游戏等各项版权推荐开发。</p>
					</div>
					<img class="rew_hand" src="../assets/images/zhengwen_2018/nav_hand.png" alt="" srcset="">
				</div>
			</div>
		</div>
		<div class="list list_4">
			<div class="conter">
				<h1>评审规则</h1>
				<div class="zw_time">
					<h4>初赛：</h4>
					<p>初赛时间：<span>2018.09.01——2019.01.31</span></p>
					<p>初赛评选规则：</p>
					<p>1. 根据作品点击量，根据成绩由高到低筛选出20部进入决赛
					<p>2. 若某部作品，获得3名及其以上评委联名推荐，可直接进入决赛，直接进入决赛总数量不超10部</p>
				</div>
				<div class="zw_time">
					<h4>决赛：</h4>		 
					<p>决赛时间：<span>2019.02.01——2019.03.30</span></p>
					<p>决赛评选规则：</p>
					<p>1. 由专家评委团、读者投票两者组成，所占权重比分别为40：60.</p>
					<p>2. 暗夜文学编辑会对进入决赛作品辅助作者制作详细大纲和样章，提交给大赛评委组。评委组进行不记名投票，通过打分去除最高分以及最低分取其平均分为作品成绩。评委组所打分数占作品总成绩40%。</p>
					<p>3. 读者为喜欢的作品投星钻，读者星钻占作品总成绩60%。</p>
					<p>4. 结果宣布时间：<span>2019.04.15</span></p>
					<p>5. 奖金会随当月稿费一同发放，奖项发放完全后，获奖作品正式进入版权开发衍生环。</p>
				</div>
			</div>
		</div>
		<div class="list list_5">
			<div class="conter">
				<h1>大赛展示</h1>
				<ul>
					<li v-for="(item,index) in book">
						<div class="book_list_box">
							<img :src="item.imagefname" alt="item.title" class="book-cover">
							<img src="../assets/images/zhengwen_2018/label.png" alt="" class="label">
							<div class="book_border"></div>
						</div>
						<p class="book_name">{{item.title}}</p>
						<p class="auther">{{item.author}}</p>
						<p class="click">点击量：{{item.totalviews}}</p>
					</li>
				</ul>
				<div style="text-align:center">
					<div :class="allPage > 1 ? 'pager' : 'hiden'">
						<a v-for="(item,index) in allPage" @click="clickPage(index)" :class="{current : index+1 == page}">{{index+1}}</a>
					</div>
				</div>
				<div class="go_link">
					<a href="http://author.anyew.cn/">我要参赛</a>
				</div>
			</div>
		</div>
		<div class="list list_6">
			<div class="conter">
				<h1>评委名单</h1>
				<ul>
					<li>						
						<div class="img_box">
							<img src="../assets/images/zhengwen_2018/judges_gusibin.png">
						</div>
						<p class="book-name">顾思斌</p>
						<p class="auther">猫眼文化传媒</br>总裁</p>
					</li>
					<li>						
						<div class="img_box">
							<img src="../assets/images/zhengwen_2018/judges_chenfang.png">
						</div>
						<p class="book-name">陈芳</p>
						<p class="auther">GameArk</br>CEO</p>
					</li>
					<li>						
						<div class="img_box">
							<img src="../assets/images/zhengwen_2018/judges_chenrongyan.png">
						</div>
						<p class="book-name">陈蓉妍</p>
						<p class="auther">广州莱可映相传媒</br>CEO 总制片人</p>
					</li>
					<li>						
						<div class="img_box">
							<img src="../assets/images/zhengwen_2018/judges_tanyanfeng.png">
						</div>
						<p class="book-name">谭雁峰</p>
						<p class="auther">盛大游戏</br>副总裁</p>
					</li>
					<li>						
						<div class="img_box">
							<img src="../assets/images/zhengwen_2018/judges_shizhong.png">
						</div>
						<p class="book-name">施忠</p>
						<p class="auther">惊奇大地</br>总裁</p>
					</li>
					<li>						
						<div class="img_box">
							<img src="../assets/images/zhengwen_2018/judges_yuanxionggui.png">
						</div>
						<p class="book-name">袁雄贵</p>
						<p class="auther">天舟文化</br>副董事长 执行总裁</p>
					</li>
					<li>						
						<div class="img_box">
							<img src="../assets/images/zhengwen_2018/judges_dongguanjie.png">
						</div>
						<p class="book-name">董冠杰</p>
						<p class="auther">奇树有鱼</br>创始人 董事长 CEO</p>
					</li>
					<li>						
						<div class="img_box">
							<img src="../assets/images/zhengwen_2018/judges_liangjie.png">
						</div>
						<p class="book-name">梁洁</p>
						<p class="auther">中南天使图书部</br>总监</p>
					</li>
					<li>						
						<div class="img_box">
							<img src="../assets/images/zhengwen_2018/judges_yangyong.png">
						</div>
						<p class="book-name">杨勇</p>
						<p class="auther">爱奇艺文学事业部</br>总编辑</p>
					</li>
					<li>						
						<div class="img_box">
							<img src="../assets/images/zhengwen_2018/judges_zhouyiming.png">
						</div>
						<p class="book-name">周奕明</p>
						<p class="auther">庸和集团</br>创始人</p>
					</li>
				</ul>
				<p class="judges_order">以上排名不分先后</p>
			</div>
		</div>
		<div class="list list_7">
			<div class="conter">
				<h1>举办单位</h1>
				<h4>主办方<span></span></h4>
				<div class="logo_list clearfix">
					<img src="../assets/images/zhengwen_2018/logo.png" alt="">
				</div>
				<h4>战略合作伙伴<span></span></h4>
				<div class="logo_list clearfix">
					<img src="../assets/images/zhengwen_2018/logo_1.png" alt="">
					<img src="../assets/images/zhengwen_2018/logo_2.png" alt="">
					<img src="../assets/images/zhengwen_2018/logo_3.png" alt="">
					<img src="../assets/images/zhengwen_2018/logo_4.png" alt="">
					<img src="../assets/images/zhengwen_2018/logo_5.png" alt="">
					<img src="../assets/images/zhengwen_2018/logo_6.png" alt="">
					<img src="../assets/images/zhengwen_2018/logo_7.png" alt="">
					<img src="../assets/images/zhengwen_2018/logo_8.png" alt="">
					<img src="../assets/images/zhengwen_2018/logo_9.png" alt="">
					<img src="../assets/images/zhengwen_2018/logo_10.png" alt="">
				</div>
			</div>
		</div>
		<div class="list list_8">
			<div class="conter">
				<h1>关于暗夜</h1>
				<p>暗夜文学网成立于2016年，新生代群体阅读平台，主要以灵异、悬疑、都市等作品为主，目前已经成长为中国最大的悬疑灵异文学基地之一。</p>
				<p>暗夜文学聚焦于IP产业上游的内容培育及运营，拥有上万名作者、数万部优秀全版权作品、五千万注册用户，已成功打造多部全网知名作品，并陆续改编影视游戏。</p>
				<p>自创站以来，暗夜文学网策划出品了《民间风水奇谭》、《凶棺》、《窃玉生香》、《余生安然》等一批订阅破百万作品和畅销书。其中《余生安然》、《窃玉生香》等七十余部作品被改编为游戏影视有声漫画……</p>
				<p>公司现拥有5000余部全版权作品，10万余部数字版权作品。与300余家企业达成合作共识，其中包括爱奇艺、腾讯、盛大游戏、猫眼文化、快看漫画、阿里巴巴、搜狗阅读、奇树有鱼……涵盖所有主流影视、游戏、动漫、文学渠道及制作方代表。</p>
				<p>同时，暗夜文学的兄弟公司——2017年最亮眼的漫画IP培育平台《万画筒》及有声广播剧新生代品牌《情声》将全力协助配合此次征文及后续活动，助力作品IP改编。</p>
			</div>
		</div>
		<div class="list list_9">
			<div class="conter">
				<h1>投稿通道</h1>
				<p>1、直接登陆大赛参赛网址<a href="http://ds.anyew.cn/">ds.anyew.cn</a>或从暗夜文学网（<a href="http://www.anyew.cn/">www.anyew.cn</a>）登陆——暗夜杯首届全球华文泛悬疑专题，点击“<span>我要参赛</span>”按钮即可参与；</p>
				<div class="add_btn">
					<a href="http://author.anyew.cn/">我要参赛</a>
				</div>
				<p>2.或选择以下任意一位资深编辑，进行投稿即可，请勿一稿多投。 </p>
				<div class="editer clearfix">
					<p class="type">男频</p>
					<p>太子：205353904@qq.com</br>
						扶苏：3144313956@qq.com</br>
						长风：503082694@qq.com</br>
						晨阳：1104842363@qq.com </p>
					<p class="type">女频</p>
					<p>云舒：2509862516@qq.com</br>
						素素：3288604367@qq.com</br>
						四海：55537005@qq.com</p>
				</div>
			</div>
		</div>
		<div class="list list_10">
			<div class="conter">
				<h1>参赛须知</h1>
				<p>
					1.本届大赛以“暗夜文学”：<a href="http://www.anyew.cn/">http://www.anyew.cn/ </a>原创文学网站作为线上征集活动，诚邀投稿参赛</br>
					2.参赛作品须保证为参赛者原创作品。严禁出现抄袭、高仿等侵犯其他文学著作权的行为，一经发现立即取消涉嫌侵权作品的参赛资格并追回稿费，情节严重者，本公司将通过法律途径维护自身权益</br>
					3.参赛作品需符合我国法律法规及公序良俗的要求，不得违反国家政策法规的规定（包括但不限于损害国家党政形象，破坏祖国团结统一，宣扬色情、暴力、封建迷信等思想，侮辱民族宗教信仰及生活习俗），一经发现立即取消参赛者资格，由此给举办方—暗夜文学带来的损失由该参赛者承担</br>
					4.此次大赛禁止恶性刷票，一经发现，取消参赛资格</br>
					5.获奖作品如签约后所得收益未超过奖金，则大赛结束后，以补差额形式补满；若签约后获得收益超出奖金金额，则以原合同金额为准，并获得其他奖励</br>
					6.参赛作品所得税由主办方代扣代缴</br>
					7.参赛者应保证参赛作品版权清晰；获奖作品如后期恶意灌水等，网站有权勒令修改或完本</br>
					8.本赛事为免费参加，不收取任何形式的参赛费，凡以本赛事名义收取报名等费用的行为皆属欺诈行为，谨防上当受骗</br>
					9.所有征集作品均不退稿，请参赛者注意保留原件</br>
					10.暗夜文学拥有此次征文大赛的最终解释权    
				</p>
			</div>
		</div>
		<div class="menu_list hiden">
			<ul>
				<li class="act">导语</li>
				<li>作品范围</li>
				<li>大赛奖励</li>
				<li>评审规则</li>
				<li>大赛展示</li>
				<li>评委名单</li>
				<li>举办单位</li>
				<li>关于暗夜</li>
				<li>投稿通道</li>
				<li>参赛须知</li>
			</ul>
		</div>
	</div>
	
</template>

<script>
export default {
  name: 'anyezwpc',
  data () {
    return {
      page: 1,
      allPage:1,
      limit:15,
      book:[], 
	  scroll: ''
    }
  },
  mounted() {     
    this.getbooklist();
	this.system()
  },  
  methods:{
		getbooklist() {    
			this.$http.get(api+'/action/contests',{
			params:{
				page:this.page,
				limit:this.limit
			} 
			}).then(function(result) {             
			this.book = result.data.data.book;
			this.allPage = parseInt(result.data.data.allPage);
			// console.log(this.book )              
			})      
		},
		clickPage(index) { 
			this.page = index + 1;          
			this.getbooklist()                               
		},
		system(){
			 //平台、设备和操作系统 
			var system = { 
				win: false, 
				mac: false, 
				xll: false, 
				ipad:false 
			}; 
			//检测平台 
			var p = navigator.platform; 
			system.win = p.indexOf("Win") == 0; 
			system.mac = p.indexOf("Mac") == 0; 
			system.x11 = (p == "X11") || (p.indexOf("Linux") == 0); 
			system.ipad = (navigator.userAgent.match(/iPad/i) != null)?true:false; 
			//跳转语句，如果是手机访问就自动跳转到wap.baidu.com页面 
			if (system.win || system.mac || system.xll||system.ipad) { 

			} else { 
				this.$router.push({ path: 'anye_zw_wap' })
			};
		}
	}
}

$(function(){
	var isScroll = true;
	$(".menu_list ul li").click(function() {
		isScroll = false;
		var idindex = $(this).index();
		$(this).addClass("act").siblings("li").removeClass("act");
		$('html,body').animate({
			scrollTop: $('.zw_box .list').eq(idindex).offset().top-80,
		},1000);
		setTimeout(function (){
			isScroll = true;
		},1000); 	
	});
	//滚动条事件
	$(window).scroll(function() {
		if( isScroll == true ){
			//获取滚动条的滑动距离
			for(var i = 0; i < $(".zw_box .list").length; i++) {
				var scroH = $(this).scrollTop();
				if(scroH>500){
					$(".menu_list").removeClass('hiden')
				}else{
					$(".menu_list").addClass('hiden')	
				}
				var a = $(".zw_box .list").eq(i).offset().top - scroH;		
				if(a <= 500) {
					$(".menu_list ul li").eq(i).addClass("act").siblings("li").removeClass("act");
				}
			}
		}
	});
})

</script>
<style scoped>
@import url("../assets/css/anyewang_zhengwen_2018.css");
</style>



// WEBPACK FOOTER //
// src/router/AnyeZwpc.vue